import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import Moment from 'moment';
import { customStyles } from '../../../../helpers/modal_styles';
import { onEditarContador } from '../../../../services/contadores/contadoresService';
import './ContadoresEditModal.css';

export const ContadoresEditModal = ({
    setModalEditar,
    modalEditar,
    editar,
    onReload
}) => {
    const dispatch = useDispatch();
    Modal.setAppElement("#root");

    const [formValues, setFormValues] = useState({
        id: '',
        nombrerazonsocial: '',
        cedula: '',
        telefono: '',
        email: '',
        estado: 1,
        tipo_membresia: '',
        fecha_vencimiento: '',
        cantidad_clientes: 0,
        cantidad_auxiliares: 0
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (editar && editar.id) {
            setFormValues({
                id: editar.id,
                nombrerazonsocial: editar.nombrerazonsocial || '',
                cedula: editar.cedula || '',
                telefono: editar.telefono || '',
                email: editar.email || '',
                estado: editar.estado !== undefined ? editar.estado : 1,
                tipo_membresia: editar.tipo_membresia || '',
                fecha_vencimiento: editar.fecha_vencimiento || '',
                cantidad_clientes: editar.cantidad_clientes || 0,
                cantidad_auxiliares: editar.cantidad_auxiliares || 0
            });
            setErrors({});
        }
    }, [editar]);

    const closeModal = () => {
        setModalEditar(false);
        setErrors({});
    };

    const validateFields = () => {
        const newErrors = {};

        if (!formValues.nombrerazonsocial?.trim()) {
            newErrors.nombrerazonsocial = 'La razón social es requerida';
        }

        if (!formValues.cedula?.trim()) {
            newErrors.cedula = 'La cédula es requerida';
        }

        if (!formValues.telefono?.trim()) {
            newErrors.telefono = 'El teléfono es requerido';
        }

        if (!formValues.email?.trim()) {
            newErrors.email = 'El email es requerido';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)) {
            newErrors.email = 'El email no es válido';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFields()) {
            return;
        }

        try {
            const resultado = await dispatch(
                onEditarContador(
                    formValues.id,
                    formValues.nombrerazonsocial,
                    formValues.cedula,
                    formValues.telefono,
                    formValues.email,
                    formValues.estado
                )
            );

            if (resultado) {
                closeModal();
                onReload();
            }
        } catch (error) {
            console.log('Error:', error);
            Swal.fire('Error', 'Error al guardar los cambios', 'error');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value
        });
    };

    const handleCheckboxChange = (e) => {
        setFormValues({
            ...formValues,
            estado: e.target.checked ? 1 : 0
        });
    };

    return (
        <Modal
            isOpen={modalEditar}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Editar Contador"
        >
            <div className="popup">
                <center>
                    <h3>Editar Contador</h3>
                </center>
                <br />
                <form onSubmit={handleSubmit}>
                    <div className="form-group-custom">
                        <label><strong>Razón Social</strong></label>
                        <input
                            type="text"
                            name="nombrerazonsocial"
                            className={`input-custom ${errors.nombrerazonsocial ? 'input-error' : ''}`}
                            value={formValues.nombrerazonsocial}
                            onChange={handleInputChange}
                        />
                        {errors.nombrerazonsocial && (
                            <div className="error-message">
                                {errors.nombrerazonsocial}
                            </div>
                        )}
                    </div>

                    <div className="form-row-custom">
                        <div className="form-group-custom">
                            <label><strong>Cédula</strong></label>
                            <input
                                type="text"
                                name="cedula"
                                className={`input-custom ${errors.cedula ? 'input-error' : ''}`}
                                value={formValues.cedula}
                                onChange={handleInputChange}
                            />
                            {errors.cedula && (
                                <div className="error-message">
                                    {errors.cedula}
                                </div>
                            )}
                        </div>
                        <div className="form-group-custom">
                            <label><strong>Teléfono</strong></label>
                            <input
                                type="text"
                                name="telefono"
                                className={`input-custom ${errors.telefono ? 'input-error' : ''}`}
                                value={formValues.telefono}
                                onChange={handleInputChange}
                            />
                            {errors.telefono && (
                                <div className="error-message">
                                    {errors.telefono}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="form-group-custom">
                        <label><strong>Email</strong></label>
                        <input
                            type="email"
                            name="email"
                            className={`input-custom ${errors.email ? 'input-error' : ''}`}
                            value={formValues.email}
                            onChange={handleInputChange}
                        />
                        {errors.email && (
                            <div className="error-message">
                                {errors.email}
                            </div>
                        )}
                    </div>

                    <div className="form-row-custom">
                        <div className="form-group-custom">
                            <label><strong>Tipo de Membresía</strong></label>
                            <input
                                type="text"
                                name="tipo_membresia"
                                className="input-custom"
                                value={formValues.tipo_membresia}
                                disabled
                            />
                            <small>Solo lectura</small>
                        </div>
                        <div className="form-group-custom">
                            <label><strong>Fecha Vencimiento</strong></label>
                            <input
                                type="text"
                                name="fecha_vencimiento"
                                className="input-custom"
                                value={formValues.fecha_vencimiento ? Moment(formValues.fecha_vencimiento).format("D MMM YYYY") : ''}
                                disabled
                            />
                            <small>Solo lectura</small>
                        </div>
                    </div>

                    <div className="form-row-custom">
                        <div className="form-group-custom">
                            <label><strong>Cantidad Clientes</strong></label>
                            <input
                                type="number"
                                name="cantidad_clientes"
                                className="input-custom"
                                value={formValues.cantidad_clientes}
                                disabled
                            />
                            <small>Solo lectura</small>
                        </div>
                        <div className="form-group-custom">
                            <label><strong>Cantidad Auxiliares</strong></label>
                            <input
                                type="number"
                                name="cantidad_auxiliares"
                                className="input-custom"
                                value={formValues.cantidad_auxiliares}
                                disabled
                            />
                            <small>Solo lectura</small>
                        </div>
                    </div>

                    <div className="form-group-custom">
                        <label><strong>Estado</strong></label>
                        <div className="estado-toggle">
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    name="estado"
                                    checked={formValues.estado === 1}
                                    onChange={handleCheckboxChange}
                                    className="estado-checkbox"
                                />
                                <span className="checkbox-text">
                                    {formValues.estado === 1 ? "Activo" : "Inactivo"}
                                </span>
                            </label>
                        </div>
                    </div>

                    <div className="button-group">
                        <button type="submit" className="btn-save">
                            Guardar
                        </button>
                        <button type="button" className="btn-cancel" onClick={closeModal}>
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
